//!function(a,b){"use strict";"function"==typeof define&&define.amd?define(["jquery"],function(c){return b(c,a,a.document,a.Math)}):"undefined"!=typeof exports?module.exports=b(require("jquery"),a,a.document,a.Math):b(jQuery,a,a.document,a.Math)}("undefined"!=typeof window?window:this,function(a,b,c,d,e){"use strict";var f="fullpage-wrapper",g="."+f,h="fp-scrollable",i="."+h,l="fp-responsive",m="fp-notransition",n="fp-destroyed",o="fp-enabled",p="fp-viewing",q="active",r="."+q,s="fp-completely",t="."+s,u=".section",v="fp-section",w="."+v,x=w+r,y=w+":first",z=w+":last",A="fp-tableCell",B="."+A,C="fp-auto-height",E="fp-normal-scroll",G="fp-nav",H="#"+G,I="fp-tooltip",J="."+I,K="fp-show-active",L=".slide-fp",M="fp-slide",N="."+M,O=N+r,P="fp-slides",Q="."+P,R="fp-slidesContainer",S="."+R,T="fp-table",U="fp-slidesNav",V="."+U,W=V+" a",X="fp-controlArrow",Y="."+X,Z="fp-prev",$="."+Z,_=X+" "+Z,aa=Y+$,ba="fp-next",ca="."+ba,da=X+" "+ba,ea=Y+ca,fa=a(b),ga=a(c),ha={scrollbars:!0,mouseWheel:!0,hideScrollbars:!1,fadeScrollbars:!1,disableMouse:!0};a.fn.fullpage=function(h){function ya(){h.css3&&(h.css3=bc()),h.scrollBar=h.scrollBar||h.hybrid,Aa(),Ba(),k.setAllowScrolling(!0),k.setAutoScrolling(h.autoScrolling,"internal");var b=a(x).find(O);b.length&&(0!==a(x).index(w)||0===a(x).index(w)&&0!==b.index())&&kc(b),Hb(),ac(),"complete"===c.readyState&&qb(),fa.on("load",qb)}function za(){fa.on("scroll",Pa).on("hashchange",rb).blur(yb).resize(Gb),ga.keydown(sb).keyup(ub).on("click touchstart",H+" a",zb).on("click touchstart",W,Ab).on("click",J,tb),a(w).on("click touchstart",Y,xb),h.normalScrollElements&&(ga.on("mouseenter",h.normalScrollElements,function(){k.setMouseWheelScrolling(!1)}),ga.on("mouseleave",h.normalScrollElements,function(){k.setMouseWheelScrolling(!0)}))}function Aa(){var b=$.find(h.sectionSelector);h.anchors.length||(h.anchors=b.filter("[data-anchor]").map(function(){return a(this).data("anchor").toString()}).get()),h.navigationTooltips.length||(h.navigationTooltips=b.filter("[data-tooltip]").map(function(){return a(this).data("tooltip").toString()}).get())}function Ba(){$.css({height:"100%",position:"relative"}),$.addClass(f),a("html").addClass(o),ba=fa.height(),$.removeClass(n),Fa(),a(w).each(function(b){var c=a(this),d=c.find(N),e=d.length;Da(c,b),Ea(c,b),e>0?Ca(c,d,e):h.verticalCentered&&Rb(c)}),h.fixedElements&&h.css3&&a(h.fixedElements).appendTo(j),h.navigation&&Ha(),Ja(),Ka(),h.scrollOverflow?("complete"===c.readyState&&Ia(),fa.on("load",Ia)):Ma()}function Ca(b,c,d){var e=100*d,f=100/d;c.wrapAll('<div class="'+R+'" />'),c.parent().wrap('<div class="'+P+'" />'),b.find(S).css("width",e+"%"),d>1&&(h.controlArrows&&Ga(b),h.slidesNavigation&&Yb(b,d)),c.each(function(b){a(this).css("width",f+"%"),h.verticalCentered&&Rb(a(this))});var g=b.find(O);g.length&&(0!==a(x).index(w)||0===a(x).index(w)&&0!==g.index())?kc(g):c.eq(0).addClass(q)}function Da(b,c){c||0!==a(x).length||b.addClass(q),b.css("height",ba+"px"),h.paddingTop&&b.css("padding-top",h.paddingTop),h.paddingBottom&&b.css("padding-bottom",h.paddingBottom),"undefined"!=typeof h.sectionsColor[c]&&b.css("background-color",h.sectionsColor[c]),"undefined"!=typeof h.anchors[c]&&b.attr("data-anchor",h.anchors[c])}function Ea(b,c){"undefined"!=typeof h.anchors[c]&&b.hasClass(q)&&Nb(h.anchors[c],c),h.menu&&h.css3&&a(h.menu).closest(g).length&&a(h.menu).appendTo(j)}function Fa(){a(h.sectionSelector).each(function(){a(this).addClass(v)}),a(h.slideSelector).each(function(){a(this).addClass(M)})}function Ga(a){a.find(Q).after('<div class="'+_+'"></div><div class="'+da+'"></div>'),"#fff"!=h.controlArrowColor&&(a.find(ea).css("border-color","transparent transparent transparent "+h.controlArrowColor),a.find(aa).css("border-color","transparent "+h.controlArrowColor+" transparent transparent")),h.loopHorizontal||a.find(aa).hide()}function Ha(){j.append('<div id="'+G+'"><ul></ul></div>');var b=a(H);b.addClass(function(){return h.showActiveTooltip?K+" "+h.navigationPosition:h.navigationPosition});for(var c=0;c<a(w).length;c++){var d="";h.anchors.length&&(d=h.anchors[c]);var e='<li><a href="#'+d+'"><span></span></a>',f=h.navigationTooltips[c];"undefined"!=typeof f&&""!==f&&(e+='<div class="'+I+" "+h.navigationPosition+'">'+f+"</div>"),e+="</li>",b.find("ul").append(e)}a(H).css("margin-top","-"+a(H).height()/2+"px"),a(H).find("li").eq(a(x).index(w)).find("a").addClass(q)}function Ia(){a(w).each(function(){var b=a(this).find(N);b.length?b.each(function(){Qb(a(this))}):Qb(a(this))}),Ma()}function Ja(){$.find('iframe[src*="youtube.com/embed/"]').each(function(){var b=La(a(this).attr("src"));a(this).attr("src",a(this).attr("src")+b+"enablejsapi=1")})}function Ka(){$.find('iframe[src*="player.vimeo.com/"]').each(function(){var b=La(a(this).attr("src"));a(this).attr("src",a(this).attr("src")+b+"api=1")})}function La(a){return/\?/.test(a)?"&":"?"}function Ma(){var b=a(x);b.addClass(s),h.scrollOverflowHandler.afterRender&&h.scrollOverflowHandler.afterRender(b),mb(b),nb(b),a.isFunction(h.afterLoad)&&h.afterLoad.call(b,b.data("anchor"),b.index(w)+1),a.isFunction(h.afterRender)&&h.afterRender.call($)}function Pa(){var b;if(!h.autoScrolling||h.scrollBar){for(var d=fa.scrollTop(),e=Ra(d),f=0,g=d+fa.height()/2,i=c.querySelectorAll(w),j=0;j<i.length;++j){var k=i[j];k.offsetTop<=g&&(f=j)}if(Qa(e)&&(a(x).hasClass(s)||a(x).addClass(s).siblings().removeClass(s)),b=a(i).eq(f),!b.hasClass(q)){Na=!0;var l=a(x),m=l.index(w)+1,n=Ob(b),o=b.data("anchor"),p=b.index(w)+1,r=b.find(O);if(r.length)var t=r.data("anchor"),u=r.index();ma&&(b.addClass(q).siblings().removeClass(q),a.isFunction(h.onLeave)&&h.onLeave.call(l,m,p,n),a.isFunction(h.afterLoad)&&h.afterLoad.call(b,o,p),mb(b),Nb(o,p-1),h.anchors.length&&(ka=o,Zb(u,t,o,p))),clearTimeout(va),va=setTimeout(function(){Na=!1},100)}h.fitToSection&&(clearTimeout(wa),wa=setTimeout(function(){ma&&h.fitToSection&&(a(x).is(b)&&(ca=!0),gb(a(x)),ca=!1)},h.fitToSectionDelay))}}function Qa(b){var c=a(x).position().top,d=c+fa.height();return"up"==b?d>=fa.scrollTop()+fa.height():c<=fa.scrollTop()}function Ra(a){var b=a>Oa?"down":"up";return Oa=a,b}function Sa(a,b){if(qa.m[a]){var c,d;if("down"==a?(c="bottom",d=k.moveSectionDown):(c="top",d=k.moveSectionUp),b.length>0){if(!h.scrollOverflowHandler.isScrolled(c,b))return!0;d()}else d()}}function Xa(b){var c=b.originalEvent;if(!Ya(b.target)&&Za(c)){h.autoScrolling&&b.preventDefault();var e=a(x),f=h.scrollOverflowHandler.scrollable(e);if(ma&&!D){var g=jc(c);Va=g.y,Wa=g.x,e.find(Q).length&&d.abs(Ua-Wa)>d.abs(Ta-Va)?d.abs(Ua-Wa)>fa.outerWidth()/100*h.touchSensitivity&&(Ua>Wa?qa.m.right&&k.moveSlideRight():qa.m.left&&k.moveSlideLeft()):h.autoScrolling&&d.abs(Ta-Va)>fa.height()/100*h.touchSensitivity&&(Ta>Va?Sa("down",f):Va>Ta&&Sa("up",f))}}}function Ya(b,c){c=c||0;var d=a(b).parent();return!!(c<h.normalScrollElementTouchThreshold&&d.is(h.normalScrollElements))||c!=h.normalScrollElementTouchThreshold&&Ya(d,++c)}function Za(a){return"undefined"==typeof a.pointerType||"mouse"!=a.pointerType}function $a(a){var b=a.originalEvent;if(h.fitToSection&&i.stop(),Za(b)){var c=jc(b);Ta=c.y,Ua=c.x}}function _a(a,b){for(var c=0,e=a.slice(d.max(a.length-b,1)),f=0;f<e.length;f++)c+=e[f];return d.ceil(c/b)}function bb(c){var e=(new Date).getTime(),f=a(t).hasClass(E);if(h.autoScrolling&&!pa&&!f){c=c||b.event;var g=c.wheelDelta||-c.deltaY||-c.detail,j=d.max(-1,d.min(1,g)),k="undefined"!=typeof c.wheelDeltaX||"undefined"!=typeof c.deltaX,l=d.abs(c.wheelDeltaX)<d.abs(c.wheelDelta)||d.abs(c.deltaX)<d.abs(c.deltaY)||!k;na.length>149&&na.shift(),na.push(d.abs(g)),h.scrollBar&&(c.preventDefault?c.preventDefault():c.returnValue=!1);var m=a(x),n=h.scrollOverflowHandler.scrollable(m),o=e-ab;if(ab=e,o>200&&(na=[]),ma){var p=_a(na,10),q=_a(na,70),r=p>=q;r&&l&&(j<0?Sa("down",n):Sa("up",n))}return!1}h.fitToSection&&i.stop()}function cb(b,c){var d="undefined"==typeof c?a(x):c,e=d.find(Q),f=e.find(N).length;if(!(!e.length||D||f<2)){var g=e.find(O),i=null;if(i="prev"===b?g.prev(N):g.next(N),!i.length){if(!h.loopHorizontal)return;i="prev"===b?g.siblings(":last"):g.siblings(":first")}D=!0,Eb(e,i)}}function db(){a(O).each(function(){kc(a(this),"internal")})}function fb(a){var b=a.position(),c=b.top,d=b.top>eb,e=c-ba+a.outerHeight();return a.outerHeight()>ba?d||(c=e):(d||ca&&a.is(":last-child"))&&(c=e),eb=c,c}function gb(b,c,d){if("undefined"!=typeof b){var e=fb(b),f={element:b,callback:c,isMovementUp:d,dtop:e,yMovement:Ob(b),anchorLink:b.data("anchor"),sectionIndex:b.index(w),activeSlide:b.find(O),activeSection:a(x),leavingSection:a(x).index(w)+1,localIsResizing:ca};if(!(f.activeSection.is(b)&&!ca||h.scrollBar&&fa.scrollTop()===f.dtop&&!b.hasClass(C))){if(f.activeSlide.length)var g=f.activeSlide.data("anchor"),i=f.activeSlide.index();h.autoScrolling&&h.continuousVertical&&"undefined"!=typeof f.isMovementUp&&(!f.isMovementUp&&"up"==f.yMovement||f.isMovementUp&&"down"==f.yMovement)&&(f=jb(f)),a.isFunction(h.onLeave)&&!f.localIsResizing&&h.onLeave.call(f.activeSection,f.leavingSection,f.sectionIndex+1,f.yMovement)===!1||(ob(f.activeSection),b.addClass(q).siblings().removeClass(q),mb(b),h.scrollOverflowHandler.onLeave(),ma=!1,Zb(i,g,f.anchorLink,f.sectionIndex),hb(f),ka=f.anchorLink,Nb(f.anchorLink,f.sectionIndex))}}}function hb(b){if(h.css3&&h.autoScrolling&&!h.scrollBar){var c="translate3d(0px, -"+b.dtop+"px, 0px)";Tb(c,!0),h.scrollingSpeed?ta=setTimeout(function(){lb(b)},h.scrollingSpeed):lb(b)}else{var d=ib(b);a(d.element).animate(d.options,h.scrollingSpeed,h.easing).promise().done(function(){h.scrollBar?setTimeout(function(){lb(b)},30):lb(b)})}}function ib(a){var b={};return h.autoScrolling&&!h.scrollBar?(b.options={top:-a.dtop},b.element=g):(b.options={scrollTop:a.dtop},b.element="html, body"),b}function jb(b){return b.isMovementUp?a(x).before(b.activeSection.nextAll(w)):a(x).after(b.activeSection.prevAll(w).get().reverse()),lc(a(x).position().top),db(),b.wrapAroundElements=b.activeSection,b.dtop=b.element.position().top,b.yMovement=Ob(b.element),b}function kb(b){b.wrapAroundElements&&b.wrapAroundElements.length&&(b.isMovementUp?a(y).before(b.wrapAroundElements):a(z).after(b.wrapAroundElements),lc(a(x).position().top),db())}function lb(b){kb(b),b.element.find(".fp-scrollable").mouseover(),a.isFunction(h.afterLoad)&&!b.localIsResizing&&h.afterLoad.call(b.element,b.anchorLink,b.sectionIndex+1),h.scrollOverflowHandler.afterLoad(),nb(b.element),b.element.addClass(s).siblings().removeClass(s),console.log("visibility toggled"),ma=!0,a.isFunction(b.callback)&&b.callback.call(this),a("<style></style>").appendTo(a(c.body)).remove()}function mb(b){var b=pb(b);b.find("img[data-src], source[data-src], audio[data-src], iframe[data-src]").each(function(){a(this).attr("src",a(this).data("src")),a(this).removeAttr("data-src"),a(this).is("source")&&a(this).closest("video").get(0).load()})}function nb(b){var b=pb(b);b.find("video, audio").each(function(){var b=a(this).get(0);b.hasAttribute("data-autoplay")&&"function"==typeof b.play&&b.play()}),b.find('iframe[src*="youtube.com/embed/"]').each(function(){var b=a(this).get(0);/youtube\.com\/embed\//.test(a(this).attr("src"))&&b.hasAttribute("data-autoplay")&&b.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}',"*")})}function ob(b){var b=pb(b);b.find("video, audio").each(function(){var b=a(this).get(0);b.hasAttribute("data-keepplaying")||"function"!=typeof b.pause||b.pause()}),b.find('iframe[src*="youtube.com/embed/"]').each(function(){var b=a(this).get(0);/youtube\.com\/embed\//.test(a(this).attr("src"))&&!b.hasAttribute("data-keepplaying")&&a(this).get(0).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}',"*")})}function pb(b){var c=b.find(O);return c.length&&(b=a(c)),b}function qb(){var a=b.location.hash.replace("#","").split("/"),c=a[0],d=a[1];c&&(h.animateAnchor?Wb(c,d):k.silentMoveTo(c,d))}function rb(){if(!Na&&!h.lockAnchors){var a=b.location.hash.replace("#","").split("/"),c=a[0],d=a[1],e="undefined"==typeof ka,f="undefined"==typeof ka&&"undefined"==typeof d&&!D;c.length&&(c&&c!==ka&&!e||f||!D&&la!=d)&&Wb(c,d)}}function sb(b){clearTimeout(xa);var c=a(":focus");if(!c.is("textarea")&&!c.is("input")&&!c.is("select")&&"true"!==c.attr("contentEditable")&&""!==c.attr("contentEditable")&&h.keyboardScrolling&&h.autoScrolling){var d=b.which,e=[40,38,32,33,34];a.inArray(d,e)>-1&&b.preventDefault(),pa=b.ctrlKey,xa=setTimeout(function(){Bb(b)},150)}}function tb(){a(this).prev().trigger("click")}function ub(a){ja&&(pa=a.ctrlKey)}function vb(a){2==a.which&&(Cb=a.pageY,$.on("mousemove",Db))}function wb(a){2==a.which&&$.off("mousemove")}function xb(){var b=a(this).closest(w);a(this).hasClass(Z)?qa.m.left&&k.moveSlideLeft(b):qa.m.right&&k.moveSlideRight(b)}function yb(){ja=!1,pa=!1}function zb(b){b.preventDefault();var c=a(this).parent().index();gb(a(w).eq(c))}function Ab(b){b.preventDefault();var c=a(this).closest(w).find(Q),d=c.find(N).eq(a(this).closest("li").index());Eb(c,d)}function Bb(b){var c=b.shiftKey;switch(b.which){case 38:case 33:qa.k.up&&k.moveSectionUp();break;case 32:if(c&&qa.k.up){k.moveSectionUp();break}case 40:case 34:qa.k.down&&k.moveSectionDown();break;case 36:qa.k.up&&k.moveTo(1);break;case 35:qa.k.down&&k.moveTo(a(w).length);break;case 37:qa.k.left&&k.moveSlideLeft();break;case 39:qa.k.right&&k.moveSlideRight();break;default:return}}function Db(a){ma&&(a.pageY<Cb&&qa.m.up?k.moveSectionUp():a.pageY>Cb&&qa.m.down&&k.moveSectionDown()),Cb=a.pageY}function Eb(b,c){var e=c.position(),f=c.index(),g=b.closest(w),i=g.index(w),j=g.data("anchor"),k=g.find(V),l=_b(c),m=g.find(O),n=ca;if(h.onSlideLeave){var o=m.index(),p=Pb(o,f);if(!n&&"none"!==p&&a.isFunction(h.onSlideLeave)&&h.onSlideLeave.call(m,j,i+1,o,p,f)===!1)return void(D=!1)}ob(m),c.addClass(q).siblings().removeClass(q),n||mb(c),!h.loopHorizontal&&h.controlArrows&&(g.find(aa).toggle(0!==f),g.find(ea).toggle(!c.is(":last-child"))),g.hasClass(q)&&Zb(f,l,j,i);var s=function(){n||a.isFunction(h.afterSlideLoad)&&h.afterSlideLoad.call(c,j,i+1,l,f),nb(c),D=!1};if(h.css3){var t="translate3d(-"+d.round(e.left)+"px, 0px, 0px)";Ib(b.find(S),h.scrollingSpeed>0).css(mc(t)),ua=setTimeout(function(){s()},h.scrollingSpeed,h.easing)}else b.animate({scrollLeft:d.round(e.left)},h.scrollingSpeed,h.easing,function(){s()});k.find(r).removeClass(q),k.find("li").eq(f).find("a").addClass(q)}function Gb(){if(Hb(),F){var b=a(c.activeElement);if(!b.is("textarea")&&!b.is("input")&&!b.is("select")){var e=fa.height();d.abs(e-Fb)>20*d.max(Fb,e)/100&&(k.reBuild(!0),Fb=e)}}else clearTimeout(sa),sa=setTimeout(function(){k.reBuild(!0)},350)}function Hb(){var a=h.responsive||h.responsiveWidth,b=h.responsiveHeight,c=a&&fa.outerWidth()<a,d=b&&fa.height()<b;a&&b?k.setResponsive(c||d):a?k.setResponsive(c):b&&k.setResponsive(d)}function Ib(a){var b="all "+h.scrollingSpeed+"ms "+h.easingcss3;return a.removeClass(m),a.css({"-webkit-transition":b,transition:b})}function Jb(a){return a.addClass(m)}function Kb(a,b){var c=825,e=900;if(a<c||b<e){var f=100*a/c,g=100*b/e,h=d.min(f,g),i=h.toFixed(2);j.css("font-size",i+"%")}else j.css("font-size","100%")}function Lb(b,c){h.navigation&&(a(H).find(r).removeClass(q),b?a(H).find('a[href="#'+b+'"]').addClass(q):a(H).find("li").eq(c).find("a").addClass(q))}function Mb(b){h.menu&&(a(h.menu).find(r).removeClass(q),a(h.menu).find('[data-menuanchor="'+b+'"]').addClass(q))}function Nb(a,b){Mb(a),Lb(a,b)}function Ob(b){var c=a(x).index(w),d=b.index(w);return c==d?"none":c>d?"up":"down"}function Pb(a,b){return a==b?"none":a>b?"left":"right"}function Qb(a){if(!a.hasClass("fp-noscroll")){a.css("overflow","hidden");var f,b=h.scrollOverflowHandler,c=b.wrapContent(),d=a.closest(w),e=b.scrollable(a);e.length?f=b.scrollHeight(a):(f=a.get(0).scrollHeight,h.verticalCentered&&(f=a.find(B).get(0).scrollHeight));var g=ba-parseInt(d.css("padding-bottom"))-parseInt(d.css("padding-top"));f>g?e.length?b.update(a,g):(h.verticalCentered?a.find(B).wrapInner(c):a.wrapInner(c),b.create(a,g)):b.remove(a),a.css("overflow","")}}function Rb(a){a.addClass(T).wrapInner('<div class="'+A+'" style="height:'+Sb(a)+'px;" />')}function Sb(a){var b=ba;if(h.paddingTop||h.paddingBottom){var c=a;c.hasClass(v)||(c=a.closest(w));var d=parseInt(c.css("padding-top"))+parseInt(c.css("padding-bottom"));b=ba-d}return b}function Tb(a,b){b?Ib($):Jb($),$.css(mc(a)),setTimeout(function(){$.removeClass(m)},10)}function Ub(b){var c=$.find(w+'[data-anchor="'+b+'"]');return c.length||(c=a(w).eq(b-1)),c}function Vb(a,b){var c=b.find(Q),d=c.find(N+'[data-anchor="'+a+'"]');return d.length||(d=c.find(N).eq(a)),d}function Wb(a,b){var c=Ub(a);"undefined"==typeof b&&(b=0),a===ka||c.hasClass(q)?Xb(c,b):gb(c,function(){Xb(c,b)})}function Xb(a,b){if("undefined"!=typeof b){var c=a.find(Q),d=Vb(b,a);d.length&&Eb(c,d)}}function Yb(a,b){a.append('<div class="'+U+'"><ul></ul></div>');var c=a.find(V);c.addClass(h.slidesNavPosition);for(var d=0;d<b;d++)c.find("ul").append('<li><a href="#"><span></span></a></li>');c.css("margin-left","-"+c.width()/2+"px"),c.find("li").first().find("a").addClass(q)}function Zb(a,b,c,d){var e="";h.anchors.length&&!h.lockAnchors&&(a?("undefined"!=typeof c&&(e=c),"undefined"==typeof b&&(b=a),la=b,$b(e+"/"+b)):"undefined"!=typeof a?(la=b,$b(c)):$b(c)),ac()}function $b(a){if(h.recordHistory)location.hash=a;else if(F||X)b.history.replaceState(e,e,"#"+a);else{var c=b.location.href.split("#")[0];b.location.replace(c+"#"+a)}}function _b(a){var b=a.data("anchor"),c=a.index();return"undefined"==typeof b&&(b=c),b}function ac(){var b=a(x),c=b.find(O),d=_b(b),e=_b(c),g=(b.index(w),String(d));c.length&&(g=g+"-"+e),g=g.replace("/","-").replace("#","");var h=new RegExp("\\b\\s?"+p+"-[^\\s]+\\b","g");j[0].className=j[0].className.replace(h,""),j.addClass(p+"-"+g)}function bc(){var d,a=c.createElement("p"),f={webkitTransform:"-webkit-transform",OTransform:"-o-transform",msTransform:"-ms-transform",MozTransform:"-moz-transform",transform:"transform"};c.body.insertBefore(a,null);for(var g in f)a.style[g]!==e&&(a.style[g]="translate3d(1px,1px,1px)",d=b.getComputedStyle(a).getPropertyValue(f[g]));return c.body.removeChild(a),d!==e&&d.length>0&&"none"!==d}function cc(){c.addEventListener?(c.removeEventListener("mousewheel",bb,!1),c.removeEventListener("wheel",bb,!1),c.removeEventListener("MozMousePixelScroll",bb,!1)):c.detachEvent("onmousewheel",bb)}function dc(){var d,a="";b.addEventListener?d="addEventListener":(d="attachEvent",a="on");var f="onwheel"in c.createElement("div")?"wheel":c.onmousewheel!==e?"mousewheel":"DOMMouseScroll";"DOMMouseScroll"==f?c[d](a+"MozMousePixelScroll",bb,!1):c[d](a+f,bb,!1)}function ec(){$.on("mousedown",vb).on("mouseup",wb)}function fc(){$.off("mousedown",vb).off("mouseup",wb)}function gc(){if(F||X){var b=ic();a(g).off("touchstart "+b.down).on("touchstart "+b.down,$a),a(g).off("touchmove "+b.move).on("touchmove "+b.move,Xa)}}function hc(){if(F||X){var b=ic();a(g).off("touchstart "+b.down),a(g).off("touchmove "+b.move)}}function ic(){var a;return a=b.PointerEvent?{down:"pointerdown",move:"pointermove"}:{down:"MSPointerDown",move:"MSPointerMove"}}function jc(a){var b=[];return b.y="undefined"!=typeof a.pageY&&(a.pageY||a.pageX)?a.pageY:a.touches[0].pageY,b.x="undefined"!=typeof a.pageX&&(a.pageY||a.pageX)?a.pageX:a.touches[0].pageX,X&&Za(a)&&h.scrollBar&&(b.y=a.touches[0].pageY,b.x=a.touches[0].pageX),b}function kc(a,b){k.setScrollingSpeed(0,"internal"),"undefined"!=typeof b&&(ca=!0),Eb(a.closest(Q),a),"undefined"!=typeof b&&(ca=!1),k.setScrollingSpeed(ra.scrollingSpeed,"internal")}function lc(a){if(h.scrollBar)$.scrollTop(a);else if(h.css3){var b="translate3d(0px, -"+a+"px, 0px)";Tb(b,!1)}else $.css("top",-a)}function mc(a){return{"-webkit-transform":a,"-moz-transform":a,"-ms-transform":a,transform:a}}function nc(a,b,c){switch(b){case"up":qa[c].up=a;break;case"down":qa[c].down=a;break;case"left":qa[c].left=a;break;case"right":qa[c].right=a;break;case"all":"m"==c?k.setAllowScrolling(a):k.setKeyboardScrolling(a)}}function oc(){lc(0),a(H+", "+V+", "+Y).remove(),a(w).css({height:"","background-color":"",padding:""}),a(N).css({width:""}),$.css({height:"",position:"","-ms-touch-action":"","touch-action":""}),i.css({overflow:"",height:""}),a("html").removeClass(o),a.each(j.get(0).className.split(/\s+/),function(a,b){0===b.indexOf(p)&&j.removeClass(b)}),a(w+", "+N).each(function(){h.scrollOverflowHandler.remove(a(this)),a(this).removeClass(T+" "+q)}),Jb($),$.find(B+", "+S+", "+Q).each(function(){a(this).replaceWith(this.childNodes)}),i.scrollTop(0);var b=[v,M,R];a.each(b,function(b,c){a("."+c).removeClass(c)})}function pc(a,b,c){h[a]=b,"internal"!==c&&(ra[a]=b)}function qc(){return a("html").hasClass(o)?void rc("error","Fullpage.js can only be initialized once and you are doing it multiple times!"):(h.continuousVertical&&(h.loopTop||h.loopBottom)&&(h.continuousVertical=!1,rc("warn","Option `loopTop/loopBottom` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),h.scrollBar&&h.scrollOverflow&&rc("warn","Option `scrollBar` is mutually exclusive with `scrollOverflow`. Sections with scrollOverflow might not work well in Firefox"),h.continuousVertical&&h.scrollBar&&(h.continuousVertical=!1,rc("warn","Option `scrollBar` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),void a.each(h.anchors,function(b,c){var d=ga.find("[name]").filter(function(){return a(this).attr("name")&&a(this).attr("name").toLowerCase()==c.toLowerCase()}),e=ga.find("[id]").filter(function(){return a(this).attr("id")&&a(this).attr("id").toLowerCase()==c.toLowerCase()});(e.length||d.length)&&(rc("error","data-anchor tags can not have the same value as any `id` element on the site (or `name` element for IE)."),e.length&&rc("error",'"'+c+'" is is being used by another element `id` property'),d.length&&rc("error",'"'+c+'" is is being used by another element `name` property'))}))}function rc(a,b){console&&console[a]&&console[a]("fullPage: "+b)}if(a("html").hasClass(o))return void qc();var i=a("html, body"),j=a("body"),k=a.fn.fullpage;h=a.extend({menu:!1,anchors:[],lockAnchors:!1,navigation:!1,navigationPosition:"right",navigationTooltips:[],showActiveTooltip:!1,slidesNavigation:!1,slidesNavPosition:"bottom",scrollBar:!1,hybrid:!1,css3:!0,scrollingSpeed:700,autoScrolling:!0,fitToSection:!0,fitToSectionDelay:1e3,easing:"easeInOutCubic",easingcss3:"ease",loopBottom:!1,loopTop:!1,loopHorizontal:!0,continuousVertical:!1,normalScrollElements:null,scrollOverflow:!1,scrollOverflowHandler:ia,scrollOverflowOptions:null,touchSensitivity:5,normalScrollElementTouchThreshold:5,keyboardScrolling:!0,animateAnchor:!0,recordHistory:!0,controlArrows:!0,controlArrowColor:"#fff",verticalCentered:!0,resize:!1,sectionsColor:[],paddingTop:0,paddingBottom:0,fixedElements:null,responsive:0,responsiveWidth:0,responsiveHeight:0,sectionSelector:u,slideSelector:L,afterLoad:null,onLeave:null,afterRender:null,afterResize:null,afterReBuild:null,afterSlideLoad:null,onSlideLeave:null},h),qc(),ha=a.extend(ha,h.scrollOverflowOptions),a.extend(a.easing,{easeInOutCubic:function(a,b,c,d,e){return(b/=e/2)<1?d/2*b*b*b+c:d/2*((b-=2)*b*b+2)+c}}),k.setAutoScrolling=function(b,c){pc("autoScrolling",b,c);var d=a(x);h.autoScrolling&&!h.scrollBar?(i.css({overflow:"hidden",height:"100%"}),k.setRecordHistory(ra.recordHistory,"internal"),$.css({"-ms-touch-action":"none","touch-action":"none"}),d.length&&lc(d.position().top)):(i.css({overflow:"visible",height:"initial"}),k.setRecordHistory(!1,"internal"),$.css({"-ms-touch-action":"","touch-action":""}),lc(0),d.length&&i.scrollTop(d.position().top))},k.setRecordHistory=function(a,b){pc("recordHistory",a,b)},k.setScrollingSpeed=function(a,b){pc("scrollingSpeed",a,b)},k.setFitToSection=function(a,b){pc("fitToSection",a,b)},k.setLockAnchors=function(a){h.lockAnchors=a},k.setMouseWheelScrolling=function(a){a?(dc(),ec()):(cc(),fc())},k.setAllowScrolling=function(b,c){"undefined"!=typeof c?(c=c.replace(/ /g,"").split(","),a.each(c,function(a,c){nc(b,c,"m")})):b?(k.setMouseWheelScrolling(!0),gc()):(k.setMouseWheelScrolling(!1),hc())},k.setKeyboardScrolling=function(b,c){"undefined"!=typeof c?(c=c.replace(/ /g,"").split(","),a.each(c,function(a,c){nc(b,c,"k")})):h.keyboardScrolling=b},k.moveSectionUp=function(){var b=a(x).prev(w);b.length||!h.loopTop&&!h.continuousVertical||(b=a(w).last()),b.length&&gb(b,null,!0)},k.moveSectionDown=function(){var b=a(x).next(w);b.length||!h.loopBottom&&!h.continuousVertical||(b=a(w).first()),b.length&&gb(b,null,!1)},k.silentMoveTo=function(a,b){k.setScrollingSpeed(0,"internal"),k.moveTo(a,b),k.setScrollingSpeed(ra.scrollingSpeed,"internal")},k.moveTo=function(a,b){var c=Ub(a);"undefined"!=typeof b?Wb(a,b):c.length>0&&gb(c)},k.moveSlideRight=function(a){cb("next",a)},k.moveSlideLeft=function(a){cb("prev",a)},k.reBuild=function(b){if(!$.hasClass(n)){ca=!0;var c=fa.outerWidth();ba=fa.height(),h.resize&&Kb(ba,c),a(w).each(function(){var b=a(this).find(Q),c=a(this).find(N);h.verticalCentered&&a(this).find(B).css("height",Sb(a(this))+"px"),a(this).css("height",ba+"px"),h.scrollOverflow&&(c.length?c.each(function(){Qb(a(this))}):Qb(a(this))),c.length>1&&Eb(b,b.find(O))});var d=a(x),e=d.index(w);e&&k.silentMoveTo(e+1),ca=!1,a.isFunction(h.afterResize)&&b&&h.afterResize.call($),a.isFunction(h.afterReBuild)&&!b&&h.afterReBuild.call($)}},k.setResponsive=function(b){var c=j.hasClass(l);b?c||(k.setAutoScrolling(!1,"internal"),k.setFitToSection(!1,"internal"),a(H).hide(),j.addClass(l)):c&&(k.setAutoScrolling(ra.autoScrolling,"internal"),k.setFitToSection(ra.autoScrolling,"internal"),a(H).show(),j.removeClass(l))};var ka,la,pa,D=!1,F=navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/),X="ontouchstart"in b||navigator.msMaxTouchPoints>0||navigator.maxTouchPoints,$=a(this),ba=fa.height(),ca=!1,ja=!0,ma=!0,na=[],qa={};qa.m={up:!0,down:!0,left:!0,right:!0},qa.k=a.extend(!0,{},qa.m);var sa,ta,ua,va,wa,xa,ra=a.extend(!0,{},h);a(this).length&&(ya(),za());var Na=!1,Oa=0,Ta=0,Ua=0,Va=0,Wa=0,ab=(new Date).getTime(),eb=0,Cb=0,Fb=ba;k.destroy=function(b){k.setAutoScrolling(!1,"internal"),k.setAllowScrolling(!1),k.setKeyboardScrolling(!1),$.addClass(n),clearTimeout(ua),clearTimeout(ta),clearTimeout(sa),clearTimeout(va),clearTimeout(wa),fa.off("scroll",Pa).off("hashchange",rb).off("resize",Gb),ga.off("click",H+" a").off("mouseenter",H+" li").off("mouseleave",H+" li").off("click",W).off("mouseover",h.normalScrollElements).off("mouseout",h.normalScrollElements),a(w).off("click",Y),clearTimeout(ua),clearTimeout(ta),b&&oc()}},"undefined"!=typeof IScroll&&(IScroll.prototype.wheelOn=function(){this.wrapper.addEventListener("wheel",this),this.wrapper.addEventListener("mousewheel",this),this.wrapper.addEventListener("DOMMouseScroll",this)},IScroll.prototype.wheelOff=function(){this.wrapper.removeEventListener("wheel",this),this.wrapper.removeEventListener("mousewheel",this),this.wrapper.removeEventListener("DOMMouseScroll",this)});var ia={refreshId:null,iScrollInstances:[],onLeave:function(){var b=a(x).find(i).data("iscrollInstance")||e;"undefined"!=typeof b&&b.wheelOff()},afterLoad:function(){var b=a(x).find(i).data("iscrollInstance")||e;"undefined"!=typeof b&&b.wheelOn()},create:function(b,c){var d=b.find(i);d.height(c),d.each(function(){var b=jQuery(this),c=b.data("iscrollInstance");c&&a.each(ia.iScrollInstances,function(){a(this).destroy()}),c=new IScroll(b.get(0),ha),ia.iScrollInstances.push(c),b.data("iscrollInstance",c)})},isScrolled:function(a,b){var c=b.data("iscrollInstance");return!!c&&("top"===a?c.y>=0&&!b.scrollTop():"bottom"===a?0-c.y+b.scrollTop()+1+b.innerHeight()>=b[0].scrollHeight:void 0)},scrollable:function(a){return a.find(Q).length?a.find(O).find(i):a.find(i)},scrollHeight:function(a){return a.find(i).children().first().get(0).scrollHeight},remove:function(a){var b=a.find(i);if(b.length){var c=b.data("iscrollInstance");c.destroy(),b.data("iscrollInstance",e)}a.find(i).children().first().children().first().unwrap().unwrap()},update:function(b,c){clearTimeout(ia.refreshId),ia.refreshId=setTimeout(function(){a.each(ia.iScrollInstances,function(){a(this).get(0).refresh()})},150),b.find(i).css("height",c+"px").parent().css("height",c+"px")},wrapContent:function(){return'<div class="'+h+'"><div class="fp-scroller"></div></div>'}}});
!(function (e, n) {
    "use strict";
    "function" == typeof define && define.amd
        ? define(["jquery"], function (t) {
              return n(t, e, e.document, e.Math);
          })
        : "undefined" != typeof exports
        ? (module.exports = n(require("jquery"), e, e.document, e.Math))
        : n(jQuery, e, e.document, e.Math);
})("undefined" != typeof window ? window : this, function (e, n, t, o, i) {
    "use strict";
    var s = "fullpage-wrapper",
        a = "." + s,
        l = "fp-scrollable",
        r = "." + l,
        c = "fp-responsive",
        d = "fp-notransition",
        f = "fp-destroyed",
        u = "fp-enabled",
        h = "fp-viewing",
        p = "active",
        v = "." + p,
        m = "fp-completely",
        g = "." + m,
        S = ".section",
        w = "fp-section",
        y = "." + w,
        b = y + v,
        x = y + ":first",
        T = y + ":last",
        C = "fp-tableCell",
        k = "." + C,
        L = "fp-auto-height",
        A = "fp-normal-scroll",
        E = "fp-nav",
        M = "#" + E,
        I = "fp-tooltip",
        B = "." + I,
        O = "fp-show-active",
        H = ".slide-fp",
        P = "fp-slide",
        R = "." + P,
        D = R + v,
        z = "fp-slides",
        N = "." + z,
        V = "fp-slidesContainer",
        F = "." + V,
        q = "fp-table",
        W = "fp-slidesNav",
        U = "." + W,
        Y = U + " a",
        X = "fp-controlArrow",
        K = "." + X,
        j = "fp-prev",
        Q,
        $ = X + " " + j,
        _ = K + ("." + j),
        G = "fp-next",
        J,
        Z = X + " " + G,
        ee = K + ("." + G),
        ne = e(n),
        te = e(t),
        oe = { scrollbars: !0, mouseWheel: !0, hideScrollbars: !1, fadeScrollbars: !1, disableMouse: !0 };
    (e.fn.fullpage = function (l) {
        function r() {
            l.css3 && (l.css3 = Tn()), (l.scrollBar = l.scrollBar || l.hybrid), Q(), G(), Wn.setAllowScrolling(!0), Wn.setAutoScrolling(l.autoScrolling, "internal");
            var n = e(b).find(D);
            n.length && (0 !== e(b).index(y) || (0 === e(b).index(y) && 0 !== n.index())) && On(n), en(), xn(), "complete" === t.readyState && Ve(), ne.on("load", Ve);
        }
        function X() {
            ne.on("scroll", ve).on("hashchange", Fe).blur(je).resize(Ze),
                te
                    .keydown(qe)
                    .keyup(Ue)
                    .on("click touchstart", M + " a", Qe)
                    .on("click touchstart", Y, $e)
                    .on("click", B, We),
                e(y).on("click touchstart", K, Ke),
                l.normalScrollElements &&
                    (te.on("mouseenter", l.normalScrollElements, function () {
                        Wn.setMouseWheelScrolling(!1);
                    }),
                    te.on("mouseleave", l.normalScrollElements, function () {
                        Wn.setMouseWheelScrolling(!0);
                    }));
        }
        function Q() {
            var n = $n.find(l.sectionSelector);
            l.anchors.length ||
                (l.anchors = n
                    .filter("[data-anchor]")
                    .map(function () {
                        return e(this).data("anchor").toString();
                    })
                    .get()),
                l.navigationTooltips.length ||
                    (l.navigationTooltips = n
                        .filter("[data-tooltip]")
                        .map(function () {
                            return e(this).data("tooltip").toString();
                        })
                        .get());
        }
        function G() {
            $n.css({ height: "100%", position: "relative" }),
                $n.addClass(s),
                e("html").addClass(u),
                (_n = ne.height()),
                $n.removeClass(f),
                le(),
                e(y).each(function (n) {
                    var t = e(this),
                        o = t.find(R),
                        i = o.length;
                    se(t, n), ae(t, n), i > 0 ? J(t, o, i) : l.verticalCentered && fn(t);
                }),
                l.fixedElements && l.css3 && e(l.fixedElements).appendTo(qn),
                l.navigation && ce(),
                fe(),
                ue(),
                l.scrollOverflow ? ("complete" === t.readyState && de(), ne.on("load", de)) : pe();
        }
        function J(n, t, o) {
            var i = 100 * o,
                s = 100 / o;
            t.wrapAll('<div class="' + V + '" />'),
                t.parent().wrap('<div class="' + z + '" />'),
                n.find(F).css("width", i + "%"),
                o > 1 && (l.controlArrows && re(n), l.slidesNavigation && Sn(n, o)),
                t.each(function (n) {
                    e(this).css("width", s + "%"), l.verticalCentered && fn(e(this));
                });
            var a = n.find(D);
            a.length && (0 !== e(b).index(y) || (0 === e(b).index(y) && 0 !== a.index())) ? On(a) : t.eq(0).addClass(p);
        }
        function se(n, t) {
            t || 0 !== e(b).length || n.addClass(p),
                n.css("height", _n + "px"),
                l.paddingTop && n.css("padding-top", l.paddingTop),
                l.paddingBottom && n.css("padding-bottom", l.paddingBottom),
                "undefined" != typeof l.sectionsColor[t] && n.css("background-color", l.sectionsColor[t]),
                "undefined" != typeof l.anchors[t] && n.attr("data-anchor", l.anchors[t]);
        }
        function ae(n, t) {
            "undefined" != typeof l.anchors[t] && n.hasClass(p) && ln(l.anchors[t], t), l.menu && l.css3 && e(l.menu).closest(a).length && e(l.menu).appendTo(qn);
        }
        function le() {
            e(l.sectionSelector).each(function () {
                e(this).addClass(w);
            }),
                e(l.slideSelector).each(function () {
                    e(this).addClass(P);
                });
        }
        function re(e) {
            e.find(N).after('<div class="' + $ + '"></div><div class="' + Z + '"></div>'),
                "#fff" != l.controlArrowColor &&
                    (e.find(ee).css("border-color", "transparent transparent transparent " + l.controlArrowColor), e.find(_).css("border-color", "transparent " + l.controlArrowColor + " transparent transparent")),
                l.loopHorizontal || e.find(_).hide();
        }
        function ce() {
            qn.append('<div id="' + E + '"><ul></ul></div>');
            var n = e(M);
            n.addClass(function () {
                return l.showActiveTooltip ? O + " " + l.navigationPosition : l.navigationPosition;
            });
            for (var t = 0; t < e(y).length; t++) {
                var o = "";
                l.anchors.length && (o = l.anchors[t]);
                var i = '<li><a href="#' + o + '"><span></span></a>',
                    s = l.navigationTooltips[t];
                "undefined" != typeof s && "" !== s && (i += '<div class="' + I + " " + l.navigationPosition + '">' + s + "</div>"), (i += "</li>"), n.find("ul").append(i);
            }
            e(M).css("margin-top", "-" + e(M).height() / 2 + "px"), e(M).find("li").eq(e(b).index(y)).find("a").addClass(p);
        }
        function de() {
            e(y).each(function () {
                var n = e(this).find(R);
                n.length
                    ? n.each(function () {
                          dn(e(this));
                      })
                    : dn(e(this));
            }),
                pe();
        }
        function fe() {
            $n.find('iframe[src*="youtube.com/embed/"]').each(function () {
                var n = he(e(this).attr("src"));
                e(this).attr("src", e(this).attr("src") + n + "enablejsapi=1");
            });
        }
        function ue() {
            $n.find('iframe[src*="player.vimeo.com/"]').each(function () {
                var n = he(e(this).attr("src"));
                e(this).attr("src", e(this).attr("src") + n + "api=1");
            });
        }
        function he(e) {
            return /\?/.test(e) ? "&" : "?";
        }
        function pe() {
            var n = e(b);
            n.addClass(m),
                l.scrollOverflowHandler.afterRender && l.scrollOverflowHandler.afterRender(n),
                Re(n),
                De(n),
                e.isFunction(l.afterLoad) && l.afterLoad.call(n, n.data("anchor"), n.index(y) + 1),
                e.isFunction(l.afterRender) && l.afterRender.call($n);
        }
        function ve() {
            var n;
            if (!l.autoScrolling || l.scrollBar) {
                for (var o = ne.scrollTop(), i = ge(o), s = 0, a = o + ne.height() / 2, r = t.querySelectorAll(y), c = 0; c < r.length; ++c) {
                    var d;
                    r[c].offsetTop <= a && (s = c);
                }
                if ((me(i) && (e(b).hasClass(m) || e(b).addClass(m).siblings().removeClass(m)), !(n = e(r).eq(s)).hasClass(p))) {
                    ct = !0;
                    var f = e(b),
                        u = f.index(y) + 1,
                        h = rn(n),
                        v = n.data("anchor"),
                        g = n.index(y) + 1,
                        S = n.find(D);
                    if (S.length)
                        var w = S.data("anchor"),
                            x = S.index();
                    Zn &&
                        (n.addClass(p).siblings().removeClass(p),
                        e.isFunction(l.onLeave) && l.onLeave.call(f, u, g, h),
                        e.isFunction(l.afterLoad) && l.afterLoad.call(n, v, g),
                        Re(n),
                        ln(v, g - 1),
                        l.anchors.length && ((Un = v), wn(x, w, v, g))),
                        clearTimeout(st),
                        (st = setTimeout(function () {
                            ct = !1;
                        }, 100));
                }
                l.fitToSection &&
                    (clearTimeout(at),
                    (at = setTimeout(function () {
                        Zn && l.fitToSection && (e(b).is(n) && (Gn = !0), Ee(e(b)), (Gn = !1));
                    }, l.fitToSectionDelay)));
            }
        }
        function me(n) {
            var t = e(b).position().top,
                o = t + ne.height();
            return "up" == n ? o >= ne.scrollTop() + ne.height() : t <= ne.scrollTop();
        }
        function ge(e) {
            var n = e > dt ? "down" : "up";
            return (dt = e), n;
        }
        function Se(e, n) {
            var t, o;
            if (nt.m[e])
                if (("down" == e ? ((t = "bottom"), (o = Wn.moveSectionDown)) : ((t = "top"), (o = Wn.moveSectionUp)), n.length > 0)) {
                    if (!l.scrollOverflowHandler.isScrolled(t, n)) return !0;
                    o();
                } else o();
        }
        function we(n) {
            var t = n.originalEvent;
            if (!ye(n.target) && be(t)) {
                l.autoScrolling && n.preventDefault();
                var i = e(b),
                    s = l.scrollOverflowHandler.scrollable(i);
                if (Zn && !Kn) {
                    var a = Bn(t);
                    (ht = a.y),
                        (pt = a.x),
                        i.find(N).length && o.abs(ut - pt) > o.abs(ft - ht)
                            ? o.abs(ut - pt) > (ne.outerWidth() / 100) * l.touchSensitivity && (ut > pt ? nt.m.right && Wn.moveSlideRight() : nt.m.left && Wn.moveSlideLeft())
                            : l.autoScrolling && o.abs(ft - ht) > (ne.height() / 100) * l.touchSensitivity && (ft > ht ? Se("down", s) : ht > ft && Se("up", s));
                }
            }
        }
        function ye(n, t) {
            t = t || 0;
            var o = e(n).parent();
            return !!(t < l.normalScrollElementTouchThreshold && o.is(l.normalScrollElements)) || (t != l.normalScrollElementTouchThreshold && ye(o, ++t));
        }
        function be(e) {
            return "undefined" == typeof e.pointerType || "mouse" != e.pointerType;
        }
        function xe(e) {
            var n = e.originalEvent;
            if ((l.fitToSection && Fn.stop(), be(n))) {
                var t = Bn(n);
                (ft = t.y), (ut = t.x);
            }
        }
        function Te(e, n) {
            for (var t = 0, i = e.slice(o.max(e.length - n, 1)), s = 0; s < i.length; s++) t += i[s];
            return o.ceil(t / n);
        }
        function Ce(t) {
            var i = new Date().getTime(),
                s = e(g).hasClass(A);
            if (l.autoScrolling && !Xn && !s) {
                var a = (t = t || n.event).wheelDelta || -t.deltaY || -t.detail,
                    r = o.max(-1, o.min(1, a)),
                    c = "undefined" != typeof t.wheelDeltaX || "undefined" != typeof t.deltaX,
                    d = o.abs(t.wheelDeltaX) < o.abs(t.wheelDelta) || o.abs(t.deltaX) < o.abs(t.deltaY) || !c;
                et.length > 149 && et.shift(), et.push(o.abs(a)), l.scrollBar && (t.preventDefault ? t.preventDefault() : (t.returnValue = !1));
                var f = e(b),
                    u = l.scrollOverflowHandler.scrollable(f),
                    h = i - vt;
                var p, v, m;
                if (((vt = i), h > 200 && (et = []), Zn)) Te(et, 10) >= Te(et, 70) && d && Se(r < 0 ? "down" : "up", u);
                return !1;
            }
            l.fitToSection && Fn.stop();
        }
        function ke(n, t) {
            var o,
                i = ("undefined" == typeof t ? e(b) : t).find(N),
                s = i.find(R).length;
            if (!(!i.length || Kn || s < 2)) {
                var a = i.find(D),
                    r = null;
                if (!(r = "prev" === n ? a.prev(R) : a.next(R)).length) {
                    if (!l.loopHorizontal) return;
                    r = "prev" === n ? a.siblings(":last") : a.siblings(":first");
                }
                (Kn = !0), Je(i, r);
            }
        }
        function Le() {
            e(D).each(function () {
                On(e(this), "internal");
            });
        }
        function Ae(e) {
            var n = e.position(),
                t = n.top,
                o = n.top > mt,
                i = t - _n + e.outerHeight();
            return e.outerHeight() > _n ? o || (t = i) : (o || (Gn && e.is(":last-child"))) && (t = i), (mt = t), t;
        }
        function Ee(n, t, o) {
            if ("undefined" != typeof n) {
                var i,
                    s = {
                        element: n,
                        callback: t,
                        isMovementUp: o,
                        dtop: Ae(n),
                        yMovement: rn(n),
                        anchorLink: n.data("anchor"),
                        sectionIndex: n.index(y),
                        activeSlide: n.find(D),
                        activeSection: e(b),
                        leavingSection: e(b).index(y) + 1,
                        localIsResizing: Gn,
                    };
                if (!((s.activeSection.is(n) && !Gn) || (l.scrollBar && ne.scrollTop() === s.dtop && !n.hasClass(L)))) {
                    if (s.activeSlide.length)
                        var a = s.activeSlide.data("anchor"),
                            r = s.activeSlide.index();
                    l.autoScrolling && l.continuousVertical && "undefined" != typeof s.isMovementUp && ((!s.isMovementUp && "up" == s.yMovement) || (s.isMovementUp && "down" == s.yMovement)) && (s = Oe(s)),
                        (e.isFunction(l.onLeave) && !s.localIsResizing && !1 === l.onLeave.call(s.activeSection, s.leavingSection, s.sectionIndex + 1, s.yMovement)) ||
                            (ze(s.activeSection),
                            n.addClass(p).siblings().removeClass(p),
                            Re(n),
                            l.scrollOverflowHandler.onLeave(),
                            (Zn = !1),
                            wn(r, a, s.anchorLink, s.sectionIndex),
                            Ie(s),
                            (Un = s.anchorLink),
                            ln(s.anchorLink, s.sectionIndex));
                }
            }
        }
        function Me(e, n) {
            return console.log("working function"), e.classList.contains("active") ? n : "";
        }
        function Ie(n) {
            const t = document.getElementById("shopify-section-1590116731181");
            const o = document.getElementById("Mp4Video-1590116731181");
            if (
                (null !== t && (o.src = "https://cdn.shopify.com/s/files/1/0367/2005/0311/files/worldwide-connected-animation-wifi-globe.mp4?v=1606757250"),
                null !== t &&
                    t.classList.contains("active") &&
                    ((o.src = "https://cdn.shopify.com/s/files/1/0367/2005/0311/files/30925576-sd.mp4?v=1602275988"),
                    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
                        ? (o.src = "https://cdn.shopify.com/s/files/1/0367/2005/0311/files/30925576-sd_online-video-cutter.com.mp4?v=1603304406")
                        : (o.src = "https://cdn.shopify.com/s/files/1/0367/2005/0311/files/worldwide-connected-animation-wifi-globe.mp4?v=1606757250")),
                l.css3 && l.autoScrolling && !l.scrollBar)
            ) {
                var i = 0;
                let e = n.dtop;
                const t = document.querySelector("#page-1595379899592");
                null !== t && (t.classList.contains("active") ? (t.style.top = "1px") : (t.style.top = "0px"));
                var s = "translate3d(0px, -" + n.dtop + "px, 0px)";
                const o = document.querySelector("body");
                o.style.background = "#faf8f7";
                const a = document.querySelectorAll(".shopify-section");
                a[a.length - 1].classList.contains("active");
                let r = 0;
                navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/) && (r = 1),
                    a.forEach((n) => {
                        n.classList.contains("active") ? (console.log(r), (e = r)) : (r += parseInt(n.offsetHeight));
                    });
                const c = document.getElementById("shopify-section-page-sections-about-us-template");
                if (null !== c) {
                    r = 0;
                    for (let n = 1; n < c.childNodes.length; n++) "DIV" == c.childNodes[n].nodeName && (c.childNodes[n].classList.contains("active") ? (e = r) : ((r += parseInt(c.childNodes[n].offsetHeight)), console.log(r)));
                }
                const d = document.getElementById("shopify-section-page-sections-about-us2-template");
                if (null !== d) {
                    r = 0;
                    for (let n = 1; n < d.childNodes.length; n++) "DIV" == d.childNodes[n].nodeName && (d.childNodes[n].classList.contains("active") ? (e = r) : ((r += parseInt(d.childNodes[n].offsetHeight)), console.log(r)));
                }
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || (e = n.dtop),
                    hn((s = n.isMovementUp && parseInt(n.dtop) - 64 > 0 ? "translate3d(0px, -" + `${e}` + "px, 0px)" : "translate3d(0px, -" + n.dtop + "px, 0px)"), !0),
                    l.scrollingSpeed
                        ? (ot = setTimeout(function () {
                              Pe(n);
                          }, l.scrollingSpeed))
                        : Pe(n);
            } else {
                var a = Be(n);
                e(a.element)
                    .animate(a.options, l.scrollingSpeed, l.easing)
                    .promise()
                    .done(function () {
                        l.scrollBar
                            ? setTimeout(function () {
                                  Pe(n);
                              }, 30)
                            : Pe(n);
                    });
            }
        }
        function Be(e) {
            var n = {};
            return l.autoScrolling && !l.scrollBar ? ((n.options = { top: -e.dtop }), (n.element = a)) : ((n.options = { scrollTop: e.dtop }), (n.element = "html, body")), n;
        }
        function Oe(n) {
            return (
                n.isMovementUp ? e(b).before(n.activeSection.nextAll(y)) : e(b).after(n.activeSection.prevAll(y).get().reverse()),
                Hn(e(b).position().top),
                Le(),
                (n.wrapAroundElements = n.activeSection),
                (n.dtop = n.element.position().top),
                (n.yMovement = rn(n.element)),
                n
            );
        }
        function He(n) {
            n.wrapAroundElements && n.wrapAroundElements.length && (n.isMovementUp ? e(x).before(n.wrapAroundElements) : e(T).after(n.wrapAroundElements), Hn(e(b).position().top), Le());
        }
        function Pe(n) {
            He(n),
                n.element.find(".fp-scrollable").mouseover(),
                e.isFunction(l.afterLoad) && !n.localIsResizing && l.afterLoad.call(n.element, n.anchorLink, n.sectionIndex + 1),
                l.scrollOverflowHandler.afterLoad(),
                De(n.element),
                n.element.addClass(m).siblings().removeClass(m),
                console.log("visibility toggled"),
                (Zn = !0),
                e.isFunction(n.callback) && n.callback.call(this),
                e("<style></style>").appendTo(e(t.body)).remove();
        }
        function Re(n) {
            var n;
            (n = Ne(n)).find("img[data-src], source[data-src], audio[data-src], iframe[data-src]").each(function () {
            	console.log(e(this).data("src"));
            	var size = e(this).data("src").replace("_{width}x","");
            	console.log(size,'size');
                e(this).attr("src", size), e(this).removeAttr("data-src"), e(this).is("source") && e(this).closest("video").get(0).load();
            });
        }
        function De(n) {
            var n;
            (n = Ne(n)).find("video, audio").each(function () {
                var n = e(this).get(0);
                n.hasAttribute("data-autoplay") && "function" == typeof n.play && n.play();
            }),
                n.find('iframe[src*="youtube.com/embed/"]').each(function () {
                    var n = e(this).get(0);
                    /youtube\.com\/embed\//.test(e(this).attr("src")) && n.hasAttribute("data-autoplay") && n.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
                });
        }
        function ze(n) {
            var n;
            (n = Ne(n)).find("video, audio").each(function () {
                var n = e(this).get(0);
                n.hasAttribute("data-keepplaying") || "function" != typeof n.pause || n.pause();
            }),
                n.find('iframe[src*="youtube.com/embed/"]').each(function () {
                    var n = e(this).get(0);
                    /youtube\.com\/embed\//.test(e(this).attr("src")) && !n.hasAttribute("data-keepplaying") && e(this).get(0).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
                });
        }
        function Ne(n) {
            var t = n.find(D);
            return t.length && (n = e(t)), n;
        }
        function Ve() {
            var e = n.location.hash.replace("#", "").split("/"),
                t = e[0],
                o = e[1];
            t && (l.animateAnchor ? mn(t, o) : Wn.silentMoveTo(t, o));
        }
        function Fe() {
            if (!ct && !l.lockAnchors) {
                var e = n.location.hash.replace("#", "").split("/"),
                    t = e[0],
                    o = e[1],
                    i = "undefined" == typeof Un,
                    s = "undefined" == typeof Un && "undefined" == typeof o && !Kn;
                t.length && ((t && t !== Un && !i) || s || (!Kn && Yn != o)) && mn(t, o);
            }
        }
        function qe(n) {
            clearTimeout(lt);
            var t = e(":focus");
            if (!t.is("textarea") && !t.is("input") && !t.is("select") && "true" !== t.attr("contentEditable") && "" !== t.attr("contentEditable") && l.keyboardScrolling && l.autoScrolling) {
                var o = n.which,
                    i = [40, 38, 32, 33, 34];
                e.inArray(o, i) > -1 && n.preventDefault(),
                    (Xn = n.ctrlKey),
                    (lt = setTimeout(function () {
                        _e(n);
                    }, 150));
            }
        }
        function We() {
            e(this).prev().trigger("click");
        }
        function Ue(e) {
            Jn && (Xn = e.ctrlKey);
        }
        function Ye(e) {
            2 == e.which && ((gt = e.pageY), $n.on("mousemove", Ge));
        }
        function Xe(e) {
            2 == e.which && $n.off("mousemove");
        }
        function Ke() {
            var n = e(this).closest(y);
            e(this).hasClass(j) ? nt.m.left && Wn.moveSlideLeft(n) : nt.m.right && Wn.moveSlideRight(n);
        }
        function je() {
            (Jn = !1), (Xn = !1);
        }
        function Qe(n) {
            n.preventDefault();
            var t = e(this).parent().index();
            Ee(e(y).eq(t));
        }
        function $e(n) {
            n.preventDefault();
            var t = e(this).closest(y).find(N),
                o = t.find(R).eq(e(this).closest("li").index());
            Je(t, o);
        }
        function _e(n) {
            var t = n.shiftKey;
            switch (n.which) {
                case 38:
                case 33:
                    nt.k.up && Wn.moveSectionUp();
                    break;
                case 32:
                    if (t && nt.k.up) {
                        Wn.moveSectionUp();
                        break;
                    }
                case 40:
                case 34:
                    nt.k.down && Wn.moveSectionDown();
                    break;
                case 36:
                    nt.k.up && Wn.moveTo(1);
                    break;
                case 35:
                    nt.k.down && Wn.moveTo(e(y).length);
                    break;
                case 37:
                    nt.k.left && Wn.moveSlideLeft();
                    break;
                case 39:
                    nt.k.right && Wn.moveSlideRight();
                    break;
                default:
                    return;
            }
        }
        function Ge(e) {
            Zn && (e.pageY < gt && nt.m.up ? Wn.moveSectionUp() : e.pageY > gt && nt.m.down && Wn.moveSectionDown()), (gt = e.pageY);
        }
        function Je(n, t) {
            var i = t.position(),
                s = t.index(),
                a = n.closest(y),
                r = a.index(y),
                c = a.data("anchor"),
                d = a.find(U),
                f = bn(t),
                u = a.find(D),
                h = Gn;
            if (l.onSlideLeave) {
                var m = u.index(),
                    g = cn(m, s);
                if (!h && "none" !== g && e.isFunction(l.onSlideLeave) && !1 === l.onSlideLeave.call(u, c, r + 1, m, g, s)) return void (Kn = !1);
            }
            ze(u), t.addClass(p).siblings().removeClass(p), h || Re(t), !l.loopHorizontal && l.controlArrows && (a.find(_).toggle(0 !== s), a.find(ee).toggle(!t.is(":last-child"))), a.hasClass(p) && wn(s, f, c, r);
            var S = function () {
                h || (e.isFunction(l.afterSlideLoad) && l.afterSlideLoad.call(t, c, r + 1, f, s)), De(t), (Kn = !1);
            };
            if (l.css3) {
                var w = "translate3d(-" + o.round(i.left) + "px, 0px, 0px)";
                nn(n.find(F), l.scrollingSpeed > 0).css(Pn(w)),
                    (it = setTimeout(
                        function () {
                            S();
                        },
                        l.scrollingSpeed,
                        l.easing
                    ));
            } else
                n.animate({ scrollLeft: o.round(i.left) }, l.scrollingSpeed, l.easing, function () {
                    S();
                });
            d.find(v).removeClass(p), d.find("li").eq(s).find("a").addClass(p);
        }
        function Ze() {
            if ((en(), jn)) {
                var n = e(t.activeElement);
                if (!n.is("textarea") && !n.is("input") && !n.is("select")) {
                    var i = ne.height();
                    o.abs(i - St) > (20 * o.max(St, i)) / 100 && (Wn.reBuild(!0), (St = i));
                }
            } else
                clearTimeout(tt),
                    (tt = setTimeout(function () {
                        Wn.reBuild(!0);
                    }, 350));
        }
        function en() {
            var e = l.responsive || l.responsiveWidth,
                n = l.responsiveHeight,
                t = e && ne.outerWidth() < e,
                o = n && ne.height() < n;
            e && n ? Wn.setResponsive(t || o) : e ? Wn.setResponsive(t) : n && Wn.setResponsive(o);
        }
        function nn(e) {
            var n = "all " + l.scrollingSpeed + "ms " + l.easingcss3;
            return e.removeClass(d), e.css({ "-webkit-transition": n, transition: n });
        }
        function tn(e) {
            return e.addClass(d);
        }
        function on(e, n) {
            var t = 825,
                i = 900;
            if (e < t || n < i) {
                var s = (100 * e) / t,
                    a = (100 * n) / i,
                    l,
                    r = o.min(s, a).toFixed(2);
                qn.css("font-size", r + "%");
            } else qn.css("font-size", "100%");
        }
        function sn(n, t) {
            l.navigation &&
                (e(M).find(v).removeClass(p),
                n
                    ? e(M)
                          .find('a[href="#' + n + '"]')
                          .addClass(p)
                    : e(M).find("li").eq(t).find("a").addClass(p));
        }
        function an(n) {
            l.menu &&
                (e(l.menu).find(v).removeClass(p),
                e(l.menu)
                    .find('[data-menuanchor="' + n + '"]')
                    .addClass(p));
        }
        function ln(e, n) {
            an(e), sn(e, n);
        }
        function rn(n) {
            var t = e(b).index(y),
                o = n.index(y);
            return t == o ? "none" : t > o ? "up" : "down";
        }
        function cn(e, n) {
            return e == n ? "none" : e > n ? "left" : "right";
        }
        function dn(e) {
            if (!e.hasClass("fp-noscroll")) {
                e.css("overflow", "hidden");
                var n,
                    t = l.scrollOverflowHandler,
                    o = t.wrapContent(),
                    i = e.closest(y),
                    s = t.scrollable(e);
                s.length ? (n = t.scrollHeight(e)) : ((n = e.get(0).scrollHeight), l.verticalCentered && (n = e.find(k).get(0).scrollHeight));
                var a = _n - parseInt(i.css("padding-bottom")) - parseInt(i.css("padding-top"));
                n > a ? (s.length ? t.update(e, a) : (l.verticalCentered ? e.find(k).wrapInner(o) : e.wrapInner(o), t.create(e, a))) : t.remove(e), e.css("overflow", "");
            }
        }
        function fn(e) {
            e.addClass(q).wrapInner('<div class="' + C + '" style="height:' + un(e) + 'px;" />');
        }
        function un(e) {
            var n = _n;
            if (l.paddingTop || l.paddingBottom) {
                var t = e;
                t.hasClass(w) || (t = e.closest(y));
                var o = parseInt(t.css("padding-top")) + parseInt(t.css("padding-bottom"));
                n = _n - o;
            }
            return n;
        }
        function hn(e, n) {
            n ? nn($n) : tn($n),
                $n.css(Pn(e)),
                setTimeout(function () {
                    $n.removeClass(d);
                }, 10);
        }
        function pn(n) {
            var t = $n.find(y + '[data-anchor="' + n + '"]');
            return t.length || (t = e(y).eq(n - 1)), t;
        }
        function vn(e, n) {
            var t = n.find(N),
                o = t.find(R + '[data-anchor="' + e + '"]');
            return o.length || (o = t.find(R).eq(e)), o;
        }
        function mn(e, n) {
            var t = pn(e);
            "undefined" == typeof n && (n = 0),
                e === Un || t.hasClass(p)
                    ? gn(t, n)
                    : Ee(t, function () {
                          gn(t, n);
                      });
        }
        function gn(e, n) {
            if ("undefined" != typeof n) {
                var t = e.find(N),
                    o = vn(n, e);
                o.length && Je(t, o);
            }
        }
        function Sn(e, n) {
            e.append('<div class="' + W + '"><ul></ul></div>');
            var t = e.find(U);
            t.addClass(l.slidesNavPosition);
            for (var o = 0; o < n; o++) t.find("ul").append('<li><a href="#"><span></span></a></li>');
            t.css("margin-left", "-" + t.width() / 2 + "px"), t.find("li").first().find("a").addClass(p);
        }
        function wn(e, n, t, o) {
            var i = "";
            l.anchors.length && !l.lockAnchors && (e ? ("undefined" != typeof t && (i = t), "undefined" == typeof n && (n = e), (Yn = n), yn(i + "/" + n)) : "undefined" != typeof e ? ((Yn = n), yn(t)) : yn(t)), xn();
        }
        function yn(e) {
            if (l.recordHistory) location.hash = e;
            else if (jn || Qn) n.history.replaceState(i, i, "#" + e);
            else {
                var t = n.location.href.split("#")[0];
                n.location.replace(t + "#" + e);
            }
        }
        function bn(e) {
            var n = e.data("anchor"),
                t = e.index();
            return "undefined" == typeof n && (n = t), n;
        }
        function xn() {
            var n = e(b),
                t = n.find(D),
                o = bn(n),
                i = bn(t),
                s = (n.index(y), String(o));
            t.length && (s = s + "-" + i), (s = s.replace("/", "-").replace("#", ""));
            var a = new RegExp("\\b\\s?" + h + "-[^\\s]+\\b", "g");
            (qn[0].className = qn[0].className.replace(a, "")), qn.addClass(h + "-" + s);
        }
        function Tn() {
            var e,
                o = t.createElement("p"),
                s = { webkitTransform: "-webkit-transform", OTransform: "-o-transform", msTransform: "-ms-transform", MozTransform: "-moz-transform", transform: "transform" };
            for (var a in (t.body.insertBefore(o, null), s)) o.style[a] !== i && ((o.style[a] = "translate3d(1px,1px,1px)"), (e = n.getComputedStyle(o).getPropertyValue(s[a])));
            return t.body.removeChild(o), e !== i && e.length > 0 && "none" !== e;
        }
        function Cn() {
            t.addEventListener ? (t.removeEventListener("mousewheel", Ce, !1), t.removeEventListener("wheel", Ce, !1), t.removeEventListener("MozMousePixelScroll", Ce, !1)) : t.detachEvent("onmousewheel", Ce);
        }
        function kn() {
            var e,
                o = "";
            n.addEventListener ? (e = "addEventListener") : ((e = "attachEvent"), (o = "on"));
            var s = "onwheel" in t.createElement("div") ? "wheel" : t.onmousewheel !== i ? "mousewheel" : "DOMMouseScroll";
            "DOMMouseScroll" == s ? t[e](o + "MozMousePixelScroll", Ce, !1) : t[e](o + s, Ce, !1);
        }
        function Ln() {
            $n.on("mousedown", Ye).on("mouseup", Xe);
        }
        function An() {
            $n.off("mousedown", Ye).off("mouseup", Xe);
        }
        function En() {
            if (jn || Qn) {
                var n = In();
                e(a)
                    .off("touchstart " + n.down)
                    .on("touchstart " + n.down, xe),
                    e(a)
                        .off("touchmove " + n.move)
                        .on("touchmove " + n.move, we);
            }
        }
        function Mn() {
            if (jn || Qn) {
                var n = In();
                e(a).off("touchstart " + n.down), e(a).off("touchmove " + n.move);
            }
        }
        function In() {
            var e;
            return (e = n.PointerEvent ? { down: "pointerdown", move: "pointermove" } : { down: "MSPointerDown", move: "MSPointerMove" });
        }
        function Bn(e) {
            var n = [];
            return (
                (n.y = "undefined" != typeof e.pageY && (e.pageY || e.pageX) ? e.pageY : e.touches[0].pageY),
                (n.x = "undefined" != typeof e.pageX && (e.pageY || e.pageX) ? e.pageX : e.touches[0].pageX),
                Qn && be(e) && l.scrollBar && ((n.y = e.touches[0].pageY), (n.x = e.touches[0].pageX)),
                n
            );
        }
        function On(e, n) {
            Wn.setScrollingSpeed(0, "internal"), "undefined" != typeof n && (Gn = !0), Je(e.closest(N), e), "undefined" != typeof n && (Gn = !1), Wn.setScrollingSpeed(rt.scrollingSpeed, "internal");
        }
        function Hn(e) {
            if (l.scrollBar) $n.scrollTop(e);
            else if (l.css3) {
                var n;
                hn("translate3d(0px, -" + e + "px, 0px)", !1);
            } else $n.css("top", -e);
        }
        function Pn(e) {
            return { "-webkit-transform": e, "-moz-transform": e, "-ms-transform": e, transform: e };
        }
        function Rn(e, n, t) {
            switch (n) {
                case "up":
                    nt[t].up = e;
                    break;
                case "down":
                    nt[t].down = e;
                    break;
                case "left":
                    nt[t].left = e;
                    break;
                case "right":
                    nt[t].right = e;
                    break;
                case "all":
                    "m" == t ? Wn.setAllowScrolling(e) : Wn.setKeyboardScrolling(e);
            }
        }
        function Dn() {
            Hn(0),
                e(M + ", " + U + ", " + K).remove(),
                e(y).css({ height: "", "background-color": "", padding: "" }),
                e(R).css({ width: "" }),
                $n.css({ height: "", position: "", "-ms-touch-action": "", "touch-action": "" }),
                Fn.css({ overflow: "", height: "" }),
                e("html").removeClass(u),
                e.each(qn.get(0).className.split(/\s+/), function (e, n) {
                    0 === n.indexOf(h) && qn.removeClass(n);
                }),
                e(y + ", " + R).each(function () {
                    l.scrollOverflowHandler.remove(e(this)), e(this).removeClass(q + " " + p);
                }),
                tn($n),
                $n.find(k + ", " + F + ", " + N).each(function () {
                    e(this).replaceWith(this.childNodes);
                }),
                Fn.scrollTop(0);
            var n = [w, P, V];
            e.each(n, function (n, t) {
                e("." + t).removeClass(t);
            });
        }
        function zn(e, n, t) {
            (l[e] = n), "internal" !== t && (rt[e] = n);
        }
        function Nn() {
            return e("html").hasClass(u)
                ? void Vn("error", "Fullpage.js can only be initialized once and you are doing it multiple times!")
                : (l.continuousVertical && (l.loopTop || l.loopBottom) && ((l.continuousVertical = !1), Vn("warn", "Option `loopTop/loopBottom` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),
                  l.scrollBar && l.scrollOverflow && Vn("warn", "Option `scrollBar` is mutually exclusive with `scrollOverflow`. Sections with scrollOverflow might not work well in Firefox"),
                  l.continuousVertical && l.scrollBar && ((l.continuousVertical = !1), Vn("warn", "Option `scrollBar` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),
                  void e.each(l.anchors, function (n, t) {
                      var o = te.find("[name]").filter(function () {
                              return e(this).attr("name") && e(this).attr("name").toLowerCase() == t.toLowerCase();
                          }),
                          i = te.find("[id]").filter(function () {
                              return e(this).attr("id") && e(this).attr("id").toLowerCase() == t.toLowerCase();
                          });
                      (i.length || o.length) &&
                          (Vn("error", "data-anchor tags can not have the same value as any `id` element on the site (or `name` element for IE)."),
                          i.length && Vn("error", '"' + t + '" is is being used by another element `id` property'),
                          o.length && Vn("error", '"' + t + '" is is being used by another element `name` property'));
                  }));
        }
        function Vn(e, n) {
            console && console[e] && console[e]("fullPage: " + n);
        }
        if (e("html").hasClass(u)) Nn();
        else {
            var Fn = e("html, body"),
                qn = e("body"),
                Wn = e.fn.fullpage;
            (l = e.extend(
                {
                    menu: !1,
                    anchors: [],
                    lockAnchors: !1,
                    navigation: !1,
                    navigationPosition: "right",
                    navigationTooltips: [],
                    showActiveTooltip: !1,
                    slidesNavigation: !1,
                    slidesNavPosition: "bottom",
                    scrollBar: !1,
                    hybrid: !1,
                    css3: !0,
                    scrollingSpeed: 700,
                    autoScrolling: !0,
                    fitToSection: !0,
                    fitToSectionDelay: 1e3,
                    easing: "easeInOutCubic",
                    easingcss3: "ease",
                    loopBottom: !1,
                    loopTop: !1,
                    loopHorizontal: !0,
                    continuousVertical: !1,
                    normalScrollElements: null,
                    scrollOverflow: !1,
                    scrollOverflowHandler: ie,
                    scrollOverflowOptions: null,
                    touchSensitivity: 5,
                    normalScrollElementTouchThreshold: 5,
                    keyboardScrolling: !0,
                    animateAnchor: !0,
                    recordHistory: !0,
                    controlArrows: !0,
                    controlArrowColor: "#fff",
                    verticalCentered: !0,
                    resize: !1,
                    sectionsColor: [],
                    paddingTop: 0,
                    paddingBottom: 0,
                    fixedElements: null,
                    responsive: 0,
                    responsiveWidth: 0,
                    responsiveHeight: 0,
                    sectionSelector: S,
                    slideSelector: H,
                    afterLoad: null,
                    onLeave: null,
                    afterRender: null,
                    afterResize: null,
                    afterReBuild: null,
                    afterSlideLoad: null,
                    onSlideLeave: null,
                },
                l
            )),
                Nn(),
                (oe = e.extend(oe, l.scrollOverflowOptions)),
                e.extend(e.easing, {
                    easeInOutCubic: function (e, n, t, o, i) {
                        return (n /= i / 2) < 1 ? (o / 2) * n * n * n + t : (o / 2) * ((n -= 2) * n * n + 2) + t;
                    },
                }),
                (Wn.setAutoScrolling = function (n, t) {
                    zn("autoScrolling", n, t);
                    var o = e(b);
                    l.autoScrolling && !l.scrollBar
                        ? (Fn.css({ overflow: "hidden", height: "100%" }), Wn.setRecordHistory(rt.recordHistory, "internal"), $n.css({ "-ms-touch-action": "none", "touch-action": "none" }), o.length && Hn(o.position().top))
                        : (Fn.css({ overflow: "visible", height: "initial" }), Wn.setRecordHistory(!1, "internal"), $n.css({ "-ms-touch-action": "", "touch-action": "" }), Hn(0), o.length && Fn.scrollTop(o.position().top));
                }),
                (Wn.setRecordHistory = function (e, n) {
                    zn("recordHistory", e, n);
                }),
                (Wn.setScrollingSpeed = function (e, n) {
                    zn("scrollingSpeed", e, n);
                }),
                (Wn.setFitToSection = function (e, n) {
                    zn("fitToSection", e, n);
                }),
                (Wn.setLockAnchors = function (e) {
                    l.lockAnchors = e;
                }),
                (Wn.setMouseWheelScrolling = function (e) {
                    e ? (kn(), Ln()) : (Cn(), An());
                }),
                (Wn.setAllowScrolling = function (n, t) {
                    "undefined" != typeof t
                        ? ((t = t.replace(/ /g, "").split(",")),
                          e.each(t, function (e, t) {
                              Rn(n, t, "m");
                          }))
                        : n
                        ? (Wn.setMouseWheelScrolling(!0), En())
                        : (Wn.setMouseWheelScrolling(!1), Mn());
                }),
                (Wn.setKeyboardScrolling = function (n, t) {
                    "undefined" != typeof t
                        ? ((t = t.replace(/ /g, "").split(",")),
                          e.each(t, function (e, t) {
                              Rn(n, t, "k");
                          }))
                        : (l.keyboardScrolling = n);
                }),
                (Wn.moveSectionUp = function () {
                    var n = e(b).prev(y);
                    n.length || (!l.loopTop && !l.continuousVertical) || (n = e(y).last()), n.length && Ee(n, null, !0);
                }),
                (Wn.moveSectionDown = function () {
                    var n = e(b).next(y);
                    n.length || (!l.loopBottom && !l.continuousVertical) || (n = e(y).first()), n.length && Ee(n, null, !1);
                }),
                (Wn.silentMoveTo = function (e, n) {
                    Wn.setScrollingSpeed(0, "internal"), Wn.moveTo(e, n), Wn.setScrollingSpeed(rt.scrollingSpeed, "internal");
                }),
                (Wn.moveTo = function (e, n) {
                    var t = pn(e);
                    "undefined" != typeof n ? mn(e, n) : t.length > 0 && Ee(t);
                }),
                (Wn.moveSlideRight = function (e) {
                    ke("next", e);
                }),
                (Wn.moveSlideLeft = function (e) {
                    ke("prev", e);
                }),
                (Wn.reBuild = function (n) {
                    if (!$n.hasClass(f)) {
                        Gn = !0;
                        var t = ne.outerWidth();
                        (_n = ne.height()),
                            l.resize && on(_n, t),
                            e(y).each(function () {
                                var n = e(this).find(N),
                                    t = e(this).find(R);
                                l.verticalCentered &&
                                    e(this)
                                        .find(k)
                                        .css("height", un(e(this)) + "px"),
                                    e(this).css("height", _n + "px"),
                                    l.scrollOverflow &&
                                        (t.length
                                            ? t.each(function () {
                                                  dn(e(this));
                                              })
                                            : dn(e(this))),
                                    t.length > 1 && Je(n, n.find(D));
                            });
                        var o,
                            i = e(b).index(y);
                        i && Wn.silentMoveTo(i + 1), (Gn = !1), e.isFunction(l.afterResize) && n && l.afterResize.call($n), e.isFunction(l.afterReBuild) && !n && l.afterReBuild.call($n);
                    }
                }),
                (Wn.setResponsive = function (n) {
                    var t = qn.hasClass(c);
                    n
                        ? t || (Wn.setAutoScrolling(!1, "internal"), Wn.setFitToSection(!1, "internal"), e(M).hide(), qn.addClass(c))
                        : t && (Wn.setAutoScrolling(rt.autoScrolling, "internal"), Wn.setFitToSection(rt.autoScrolling, "internal"), e(M).show(), qn.removeClass(c));
                });
            var Un,
                Yn,
                Xn,
                Kn = !1,
                jn = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/),
                Qn = "ontouchstart" in n || navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints,
                $n = e(this),
                _n = ne.height(),
                Gn = !1,
                Jn = !0,
                Zn = !0,
                et = [],
                nt = {};
            (nt.m = { up: !0, down: !0, left: !0, right: !0 }), (nt.k = e.extend(!0, {}, nt.m));
            var tt,
                ot,
                it,
                st,
                at,
                lt,
                rt = e.extend(!0, {}, l);
            e(this).length && (r(), X());
            var ct = !1,
                dt = 0,
                ft = 0,
                ut = 0,
                ht = 0,
                pt = 0,
                vt = new Date().getTime(),
                mt = 0,
                gt = 0,
                St = _n;
            Wn.destroy = function (n) {
                Wn.setAutoScrolling(!1, "internal"),
                    Wn.setAllowScrolling(!1),
                    Wn.setKeyboardScrolling(!1),
                    $n.addClass(f),
                    clearTimeout(it),
                    clearTimeout(ot),
                    clearTimeout(tt),
                    clearTimeout(st),
                    clearTimeout(at),
                    ne.off("scroll", ve).off("hashchange", Fe).off("resize", Ze),
                    te
                        .off("click", M + " a")
                        .off("mouseenter", M + " li")
                        .off("mouseleave", M + " li")
                        .off("click", Y)
                        .off("mouseover", l.normalScrollElements)
                        .off("mouseout", l.normalScrollElements),
                    e(y).off("click", K),
                    clearTimeout(it),
                    clearTimeout(ot),
                    n && Dn();
            };
        }
    }),
        "undefined" != typeof IScroll &&
            ((IScroll.prototype.wheelOn = function () {
                this.wrapper.addEventListener("wheel", this), this.wrapper.addEventListener("mousewheel", this), this.wrapper.addEventListener("DOMMouseScroll", this);
            }),
            (IScroll.prototype.wheelOff = function () {
                this.wrapper.removeEventListener("wheel", this), this.wrapper.removeEventListener("mousewheel", this), this.wrapper.removeEventListener("DOMMouseScroll", this);
            }));
    var ie = {
        refreshId: null,
        iScrollInstances: [],
        onLeave: function () {
            var n = e(b).find(r).data("iscrollInstance") || i;
            "undefined" != typeof n && n.wheelOff();
        },
        afterLoad: function () {
            var n = e(b).find(r).data("iscrollInstance") || i;
            "undefined" != typeof n && n.wheelOn();
        },
        create: function (n, t) {
            var o = n.find(r);
            o.height(t),
                o.each(function () {
                    var n = jQuery(this),
                        t = n.data("iscrollInstance");
                    t &&
                        e.each(ie.iScrollInstances, function () {
                            e(this).destroy();
                        }),
                        (t = new IScroll(n.get(0), oe)),
                        ie.iScrollInstances.push(t),
                        n.data("iscrollInstance", t);
                });
        },
        isScrolled: function (e, n) {
            var t = n.data("iscrollInstance");
            return !!t && ("top" === e ? t.y >= 0 && !n.scrollTop() : "bottom" === e ? 0 - t.y + n.scrollTop() + 1 + n.innerHeight() >= n[0].scrollHeight : void 0);
        },
        scrollable: function (e) {
            return e.find(N).length ? e.find(D).find(r) : e.find(r);
        },
        scrollHeight: function (e) {
            return e.find(r).children().first().get(0).scrollHeight;
        },
        remove: function (e) {
            var n = e.find(r);
            var t;
            n.length && (n.data("iscrollInstance").destroy(), n.data("iscrollInstance", i));
            e.find(r).children().first().children().first().unwrap().unwrap();
        },
        update: function (n, t) {
            clearTimeout(ie.refreshId),
                (ie.refreshId = setTimeout(function () {
                    e.each(ie.iScrollInstances, function () {
                        e(this).get(0).refresh();
                    });
                }, 150)),
                n
                    .find(r)
                    .css("height", t + "px")
                    .parent()
                    .css("height", t + "px");
        },
        wrapContent: function () {
            return '<div class="' + l + '"><div class="fp-scroller"></div></div>';
        },
    };
});